// List of sensitive words to block
const SENSITIVE_WORDS = [
  // Profanity and offensive language
  'fuck', 'shit', 'damn', 'bitch', 'asshole', 'bastard', 'cunt', 'piss',
  'crap', 'hell', 'bloody', 'bugger', 'wanker', 'twat', 'prick', 'dick',
  'cock', 'pussy', 'whore', 'slut', 'bitch', 'faggot', 'nigger', 'kike',
  'chink', 'spic', 'wetback', 'towelhead', 'raghead', 'gook', 'jap',
  
  // Violence and threats
  'kill', 'murder', 'suicide', 'bomb', 'terrorist', 'attack', 'violence',
  'rape', 'molest', 'abuse', 'torture', 'execute', 'assassinate',
  
  // Drugs and illegal activities
  'cocaine', 'heroin', 'marijuana', 'weed', 'crack', 'meth', 'ecstasy',
  'lsd', 'drugs', 'dealer', 'smuggling', 'trafficking',
  
  // Hate speech and discrimination
  'nazi', 'hitler', 'holocaust', 'genocide', 'ethnic', 'racial', 'sexist',
  'homophobic', 'transphobic', 'misogynist', 'racist', 'bigot',
  
  // Spam and inappropriate content
  'spam', 'scam', 'phishing', 'malware', 'virus', 'hack', 'exploit',
  'porn', 'pornography', 'xxx', 'adult', 'sex', 'nude', 'naked',
  
  // Common variations and leetspeak
  'f*ck', 'f**k', 'f***', 'sh*t', 's**t', 'd*mn', 'd**n', 'b*tch',
  'a**hole', 'a*****e', 'f4ck', 'sh1t', 'd4mn', 'b1tch', 'a55hole',
  
  // Additional inappropriate terms
  'retard', 'retarded', 'idiot', 'moron', 'stupid', 'dumb', 'loser',
  'freak', 'weirdo', 'creep', 'pervert', 'pedophile', 'child molester'
];

// Function to check if text contains sensitive words
export function containsSensitiveWords(text: string): boolean {
  if (!text || typeof text !== 'string') return false;
  
  const normalizedText = text.toLowerCase()
    .replace(/[^\w\s]/g, '') // Remove punctuation
    .replace(/\s+/g, ' '); // Normalize spaces
  
  return SENSITIVE_WORDS.some(word => {
    // Check for exact word matches and partial matches
    const wordRegex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
    return wordRegex.test(normalizedText);
  });
}

// Function to get the first sensitive word found
export function getFirstSensitiveWord(text: string): string | null {
  if (!text || typeof text !== 'string') return null;
  
  const normalizedText = text.toLowerCase()
    .replace(/[^\w\s]/g, '')
    .replace(/\s+/g, ' ');
  
  for (const word of SENSITIVE_WORDS) {
    const wordRegex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
    if (wordRegex.test(normalizedText)) {
      return word;
    }
  }
  
  return null;
}

// Validation function for form fields
export function validateInput(text: string, fieldName: string): { isValid: boolean; error?: string } {
  if (!text || text.trim().length === 0) {
    return { isValid: true }; // Empty is valid (handled by required validation)
  }
  
  if (containsSensitiveWords(text)) {
    const sensitiveWord = getFirstSensitiveWord(text);
    return {
      isValid: false,
      error: `The ${fieldName} contains inappropriate content. Please use respectful language.`
    };
  }
  
  return { isValid: true };
}
